import { render, staticRenderFns } from "./TransferEditForm.vue?vue&type=template&id=231f352c&scoped=true&"
import script from "./TransferEditForm.vue?vue&type=script&lang=js&"
export * from "./TransferEditForm.vue?vue&type=script&lang=js&"
import style0 from "./TransferEditForm.vue?vue&type=style&index=0&id=231f352c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231f352c",
  null
  
)

export default component.exports